import PropTypes from 'prop-types';

const CssClassMixin = {
  propTypes: {
    clearTheme: PropTypes.bool,
    className: PropTypes.string,
    themeClassKey: PropTypes.string
  },

  getDefaultProps: function() {
    return {
      clearTheme: false
    };
  },

  themedClassName: function(themeClassKey, className) {
    var themedClassName = '';

    if(!this.props.clearTheme && !!themeClassKey) {
      themedClassName += Realize.themes.getCssClass(themeClassKey);
    }

    if(!!className) {
      themedClassName += ' ' + className;
    }

    return themedClassName;
  },

  className: function() {
    var themeClassKey = this.getThemeClassKey();
    var className = this.props.className;

    return this.themedClassName(themeClassKey, className);
  },

  getThemeClassKey: function() {
    var themeClassKey = this.props.themeClassKey;
    if(!!this.state && !!this.state.themeClassKey) {
      themeClassKey = this.state.themeClassKey;
    }

    return themeClassKey;
  },

  propsWithoutCSS: function() {
    var cssProps = ['className', 'themeClassKey'];
    var props = $.extend({}, this.props);
    $.each(cssProps, function(i, cssProp) {
      delete props[cssProp];
    });

    return props;
  }
};

window.CssClassMixin = CssClassMixin;
export default CssClassMixin;